"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerReducer = void 0;
const PlayerState_1 = require("./PlayerState");
const PlayerStateAction_1 = require("./PlayerStateAction");
const reduceWaiting = (action, state) => {
    if (PlayerStateAction_1.PlayerActions.isBeginPlay(action)) {
        return PlayerState_1.PlayerStates.InPlay;
    }
    else if (PlayerStateAction_1.PlayerActions.isSitOut(action)) {
        return PlayerState_1.PlayerStates.Out;
    }
    else if (PlayerStateAction_1.PlayerActions.isDisconnect(action)) {
        return PlayerState_1.PlayerStates.Disconnected;
    }
    else if (PlayerStateAction_1.PlayerActions.isObserv(action)) {
        return PlayerState_1.PlayerStates.Observer;
    }
    return state;
};
const reduceInPlay = (action, state) => {
    if (PlayerStateAction_1.PlayerActions.isWait(action)) {
        return PlayerState_1.PlayerStates.Waiting;
    }
    else if (PlayerStateAction_1.PlayerActions.isFold(action)) {
        return PlayerState_1.PlayerStates.Folded;
    }
    else if (PlayerStateAction_1.PlayerActions.isGoAllIn(action)) {
        return PlayerState_1.PlayerStates.AllIn;
    }
    else if (PlayerStateAction_1.PlayerActions.isSitOut(action)) {
        return PlayerState_1.PlayerStates.Out;
    }
    else if (PlayerStateAction_1.PlayerActions.isDisconnect(action)) {
        return PlayerState_1.PlayerStates.Disconnected;
    }
    else if (PlayerStateAction_1.PlayerActions.isObserv(action)) {
        return PlayerState_1.PlayerStates.Observer;
    }
    else if (PlayerStateAction_1.PlayerActions.isOutForever(action)) {
        return PlayerState_1.PlayerStates.ForeverOut;
    }
    return state;
};
const reduceFolded = (action, state) => {
    if (PlayerStateAction_1.PlayerActions.isWait(action)) {
        return PlayerState_1.PlayerStates.Waiting;
    }
    else if (PlayerStateAction_1.PlayerActions.isBeginPlay(action)) {
        return PlayerState_1.PlayerStates.InPlay;
    }
    else if (PlayerStateAction_1.PlayerActions.isSitOut(action)) {
        return PlayerState_1.PlayerStates.Out;
    }
    else if (PlayerStateAction_1.PlayerActions.isDisconnect(action)) {
        return PlayerState_1.PlayerStates.Disconnected;
    }
    else if (PlayerStateAction_1.PlayerActions.isObserv(action)) {
        return PlayerState_1.PlayerStates.Observer;
    }
    return state;
};
const reduceAllIn = (action, state) => {
    if (PlayerStateAction_1.PlayerActions.isWait(action)) {
        return PlayerState_1.PlayerStates.Waiting;
    }
    else if (PlayerStateAction_1.PlayerActions.isBeginPlay(action)) {
        return PlayerState_1.PlayerStates.InPlay;
    }
    else if (PlayerStateAction_1.PlayerActions.isSitOut(action)) {
        return PlayerState_1.PlayerStates.Out;
    }
    else if (PlayerStateAction_1.PlayerActions.isDisconnect(action)) {
        return PlayerState_1.PlayerStates.Disconnected;
    }
    else if (PlayerStateAction_1.PlayerActions.isObserv(action)) {
        return PlayerState_1.PlayerStates.Observer;
    }
    return state;
};
const reduceSitOut = (action, state) => {
    if (PlayerStateAction_1.PlayerActions.isWait(action)) {
        return PlayerState_1.PlayerStates.Waiting;
    }
    else if (PlayerStateAction_1.PlayerActions.isBeginPlay(action)) {
        return PlayerState_1.PlayerStates.InPlay;
    }
    else if (PlayerStateAction_1.PlayerActions.isDisconnect(action)) {
        return PlayerState_1.PlayerStates.Disconnected;
    }
    else if (PlayerStateAction_1.PlayerActions.isObserv(action)) {
        return PlayerState_1.PlayerStates.Observer;
    }
    return state;
};
const reduceForeverOut = (action, state) => {
    if (PlayerStateAction_1.PlayerActions.isWait(action)) {
        return PlayerState_1.PlayerStates.Waiting;
    }
    else if (PlayerStateAction_1.PlayerActions.isBeginPlay(action)) {
        return PlayerState_1.PlayerStates.InPlay;
    }
    else if (PlayerStateAction_1.PlayerActions.isSitOut(action)) {
        return PlayerState_1.PlayerStates.Out;
    }
    else if (PlayerStateAction_1.PlayerActions.isDisconnect(action)) {
        return PlayerState_1.PlayerStates.Disconnected;
    }
    return state;
};
const reduceDisconnected = (action, state) => {
    if (PlayerStateAction_1.PlayerActions.isWait(action)) {
        return PlayerState_1.PlayerStates.Waiting;
    }
    else if (PlayerStateAction_1.PlayerActions.isBeginPlay(action)) {
        return PlayerState_1.PlayerStates.InPlay;
    }
    else if (PlayerStateAction_1.PlayerActions.isObserv(action)) {
        return PlayerState_1.PlayerStates.Observer;
    }
    return state;
};
const reduceObserver = (action, state) => {
    if (PlayerStateAction_1.PlayerActions.isWait(action)) {
        return PlayerState_1.PlayerStates.Waiting;
    }
    else if (PlayerStateAction_1.PlayerActions.isBeginPlay(action)) {
        return PlayerState_1.PlayerStates.InPlay;
    }
    else if (PlayerStateAction_1.PlayerActions.isObserv(action)) {
        return PlayerState_1.PlayerStates.Observer;
    }
    return state;
};
const PlayerReducer = (action, state) => {
    if (PlayerState_1.PlayerStates.isWaiting(state)) {
        return reduceWaiting(action, state);
    }
    else if (PlayerState_1.PlayerStates.isForeverOut(state)) {
        return reduceForeverOut(action, state);
    }
    else if (PlayerState_1.PlayerStates.isInPlay(state)) {
        return reduceInPlay(action, state);
    }
    else if (PlayerState_1.PlayerStates.isFolded(state)) {
        return reduceFolded(action, state);
    }
    else if (PlayerState_1.PlayerStates.isAllIn(state)) {
        return reduceAllIn(action, state);
    }
    else if (PlayerState_1.PlayerStates.isOut(state)) {
        return reduceSitOut(action, state);
    }
    else if (PlayerState_1.PlayerStates.isDisconnected(state)) {
        return reduceDisconnected(action, state);
    }
    else if (PlayerState_1.PlayerStates.isObserver(state)) {
        return reduceObserver(action, state);
    }
};
exports.PlayerReducer = PlayerReducer;
//# sourceMappingURL=PlayerStateReducer.js.map